import { memo, useMemo } from 'react';
import { Box, Stack } from '@mui/system';
import { useTranslation } from 'react-i18next';

import { GapHorizontalIcon, MarginHorizontalIcon } from '@/assets/icons';
import { NumberInput } from '@/modules/common/components/inputs/components/NumberInput';

const stackSx = { width: '100%' };

type Props = {
  margin: number;
  gap: number;
  iconRotationDeg: number;
  onMarginChange: (value: number) => void;
  onGapChange: (value: number) => void;
};

function SpacingComponent({ margin, gap, iconRotationDeg, onMarginChange, onGapChange }: Props) {
  const { t } = useTranslation(['interface', 'common']);

  const iconSx = useMemo(
    () => ({
      display: 'inline-flex',
      lineHeight: 0,
      transform: `rotate(${iconRotationDeg}deg)`,
      transformOrigin: 'center',
    }),
    [iconRotationDeg],
  );

  const marginIcon = useMemo(
    () => (
      <Box component='span' sx={iconSx}>
        <MarginHorizontalIcon />
      </Box>
    ),
    [iconSx],
  );

  const gapIcon = useMemo(
    () => (
      <Box component='span' sx={iconSx}>
        <GapHorizontalIcon />
      </Box>
    ),
    [iconSx],
  );

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      spacing={1}
      sx={stackSx}
    >
      <NumberInput
        value={margin}
        unit='mm'
        prefix={marginIcon}
        onChange={onMarginChange}
        tooltip={t('properties.area.margin')}
      />
      <NumberInput
        value={gap}
        unit='mm'
        prefix={gapIcon}
        onChange={onGapChange}
        tooltip={t('properties.area.gap')}
      />
    </Stack>
  );
}

export const Spacing = memo(SpacingComponent);
